<button mat-icon-button aria-label="close modal" (click)="closeModal()">
  <mat-icon>close</mat-icon>
</button>
